import { autoinject, bindable, observable } from 'aurelia-framework';
import { FileService } from "../../../utils/file-service";

const reportToolbar = [
	'bold', 
	'italic',
	'heading',
	'divider', 
	'table', 
	'image',
	'ul',
	'ol'
];

@autoinject
export class ReportCommentEdit {
	@bindable comment?: string;
	@bindable customerId: string;
	@observable ready: boolean = false;
	@observable showCommentEditor: boolean = false;
	
	@observable toolbarItems = reportToolbar;
	
	constructor(private files: FileService) { }
	
	bind() {
		this.ready = true;
		this.showCommentEditor = !!this.comment;
	}

	attached() {
		// Set title for toolbar buttons for accessbility
		const boldBtn = document.querySelector('.tui-bold');
		if (boldBtn) { boldBtn.setAttribute('title', 'Lihavoi teksti'); }

		const italicBtn = document.querySelector('.tui-italic');
		if (italicBtn) { italicBtn.setAttribute('title', 'Kursivoi teksti'); }

		const headingBtn = document.querySelector('.tui-heading');
		if (headingBtn) { headingBtn.setAttribute('title', 'Otsikko'); }

		const tableBtn = document.querySelector('.tui-table');
		if (tableBtn) { tableBtn.setAttribute('title', 'Lisää taulukko'); }

		const imageBtn = document.querySelector('.tui-image');
		if (imageBtn) { imageBtn.setAttribute('title', 'Lisää kuva'); }

		const ulBtn = document.querySelector('.tui-ul');
		if (ulBtn) { ulBtn.setAttribute('title', 'Lisää numeroimaton lista'); }

		const olBtn = document.querySelector('.tui-ol');
		if (olBtn) { olBtn.setAttribute('title', 'Lisää numeroitu lista'); }

		const scollsyncBtn = document.querySelector('.tui-scrollsync');
		if (scollsyncBtn) { scollsyncBtn.setAttribute('title', 'Synkronoi vieritys'); }

		// Remove unused popup element
		const codeblockPopup = document.querySelector('.tui-popup-code-block-editor');
		if (codeblockPopup) { codeblockPopup.remove(); }
	}
	
	addComment = () => {
		this.showCommentEditor = true;
	}

	uploadReportImage = async (file: File | Blob) => {
		const response = await this.files.upload<{attachmentUrl: string}>(`reports/attachments/${this.customerId}`, file);

		return response.attachmentUrl;
	}
}
